<template>
  <section>
    <b-row>
      <!-- <b-form-group class="col-sm-6" label="Storefront:">
        <b-v-select v-model="reportFilters.projectId" :searchable="true" :options="projectsListAll" />
      </b-form-group> -->
      <b-form-group class="col-sm-12" label="Storefronts:">
        <b-v-select-multi :disabled="viewOnly" 
          name="form-input-storefrontIds"
          v-model="reportFilters.storefrontIds"
          :searchable="true"
          :options="projectsListAll" />
      </b-form-group>
      <b-form-group class="col-sm-6" label="Ship To Country:">
        <b-v-select :disabled="viewOnly" name="form-input-shipmentAddress-countryCode" v-model="reportFilters.countryCode" :searchable="true"
          :options="countryCodeListAll" />
      </b-form-group>

      <b-form-group class="col-sm-6" label="For Stores:" label-for="item-orderStatus">
        <b-v-select :disabled="viewOnly" v-model="reportFilters.whatStores" :searchable="true" :options="posStoreStateFilter" />
      </b-form-group>
      <b-form-group class="col-sm-6" label="Order Status:" label-for="item-orderStatus">
        <b-v-select :disabled="viewOnly" v-model="reportFilters.orderStatus" :searchable="true" :options="posOrderStatusFilter" />
      </b-form-group>
      <div v-if="reportFilters.orderStatus == 'shipped'" class="col-sm-6">
        <b-form-group label="Filter Date By:" description="The below values filter by the date selected here.">
          <b-form-select :disabled="viewOnly" v-model="reportFilters.dateType" :options="projectDateTypeOpts" />
        </b-form-group>
      </div>
      <b-form-group class="col-sm-6" label="Date Filters:" description="From Date must be before To Date">
        <b-form-select :disabled="viewOnly" v-model="reportFilters.dateFilter" :options="projectDateOpts" />
      </b-form-group>
      <template v-if="reportFilters.dateFilter == 'custom'">
        <b-form-group class="col-sm-6"  label="From Shipped Date:" description="From Date must be before To Date">
          <Flatpickr :disabled="viewOnly" v-model="reportFilters.startDate" :config="flatpickrConfig" class="form-control flatpickr-input"
            placeholder="Select date" name="startDate" />
        </b-form-group>

        <b-form-group class="col-sm-6" label="To Date (excluded!):">
          <Flatpickr :disabled="viewOnly" v-model="reportFilters.endDate" :config="flatpickrConfig" class="form-control flatpickr-input"
            placeholder="Select date" name="endDate" />
        </b-form-group>
        <div class="col-sm-12 alert alert-warning">
          <b>Explanation</b>: Setting the dates as 01/01/2000 -
          01/07/2000, will check all orders shipped <b>on or after</b> the
          1st and <b>before</b> the 7th of January.
        </div>
      </template>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  components: {
  },
  name: 'OrderedStorefrontItemsReport-form',
  props: {
    reportFilters: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      myProjs: 'getMyProjects',
      countryCodeList: 'getCountryCodeList',
      USAStateCodeList: 'getUSAStateCodeList'
    }),
    projectsListAll: {
      get() {
        return [
          // {
          //   value: '',
          //   text: 'All'
          // },
          ...this.projectsList
        ];
      }
    },
    countryCodeListAll: {
      get() {
        return [
          {
            value: '',
            text: 'All'
          },
          ...this.countryCodeList
        ];
      }
    }
  },
  data() {
    return {
      posStoreStateFilter: [
        {
          value: '',
          text: 'All Stores'
        },
        {
          value: 'notConsolidated',
          text: 'Only Included for Consolidated Stores'
        },
        {
          value: 'notHidden',
          text: 'Only Not Hidden Stores'
        }
      ],
      posOrderStatusFilter: [
        {
          value: '',
          text: 'All'
        },
        {
          value: 'awaiting_payment',
          text: 'Awaiting Payment'
        },
        {
          value: 'awaiting_shipment',
          text: 'Awaiting Shipment'
        },
        {
          value: 'pending_fulfillment',
          text: 'Pending Fulfillment'
        },
        {
          value: 'on_hold',
          text: 'On Hold'
        },
        {
          value: 'shipped',
          text: 'Shipped'
        },
        {
          value: 'cancelled',
          text: 'Cancelled'
        }
      ],
      projectDateTypeOpts: [
        { value: 'orderDate', text: 'Order Date' },
        { value: 'shipDate', text: 'Ship Date' }
      ],
      projectDateOpts: [
        // { value: '', text: "All" },
        { value: 'this-week', text: 'This Week' },
        { value: 'last-week', text: 'Last Week' },
        { value: 'this-month', text: 'This Month' },
        { value: 'last-month', text: 'Last Month' },
        { value: 'custom', text: 'Custom Date Range' }
      ],
      flatpickrConfig: {
        altFormat: 'j F Y',
        altInput: true,
        dateFormat: 'Y-m-d'
      }
    }
  }
}
</script>

<style>

</style>
